import React, { Fragment, createContext, useContext } from 'react';

type Part = null | 'header' | 'body';

type ContextProps = Part;

const Context = createContext<ContextProps>(null);

interface Props {
  children: React.ReactNode;
  part: Part;
}

export function AccordionParts(props: Props) {
  return (
    <Context.Provider value={props.part}>{props.children}</Context.Provider>
  );
}

export function AccordionPart(props: Props) {
  const selected = useContext(Context);
  return props.part === selected ? <Fragment>{props.children}</Fragment> : null;
}
